// extracted by mini-css-extract-plugin
export default {"message":"job-not-found_message__s5qID","info":"job-not-found_info__3QFx4","image":"job-not-found_image__KrI1Q"};